// Stable sentinel marking the "Lifetime" shortcut. Picked far in the past so a
// user-selected custom range can never collide with it. When this start date is
// selected we normalize the picker to a null range, which the payload maps to
// `from/to: undefined` (all-time / no date filter).
export const LIFETIME_START = new Date(0); // 1970-01-01

export const isLifetimeStart = (date: Date | null | undefined): boolean =>
	!!date && new Date(date).getTime() === LIFETIME_START.getTime();
